import './perfect-scrollbar-style.scss';

import { SidebarContainer, SidebarDoubleArrowToggleButton, SidebarLogo } from './styled';
import { SidebarContext, SidebarNavItemCollapseContext } from './context';

import Box from '@mui/material/Box';
import { DoubleArrow } from '@mui/icons-material';
import Logo from '../Logo';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SidebarList from '@/common/presentation/components/layout/Sidebar/SidebarList';
import SidebarNavUser from './SidebarList/SidebarNavUser';
import StyledDrawer from '../StyledDrawer';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import authServices from '@/auth/main/DependencyInjection';
import tid from '@/common/infrastructure/config/tid';

const Sidebar = () => {
  const { authDomainService, tokenService } = authServices;

  // Get username from token instead of localStorage to avoid corruption
  const getUserNameFromToken = () => {
    const token = tokenService.getToken();
    if (token) {
      const user = authDomainService.extractUserFromToken(token);
      return user?.userName || null;
    }
    return null;
  };

  const userName = getUserNameFromToken() || 'User';

  const { sidebarOpen, setSidebarOpen } = useContext(SidebarContext);

  const { pathname } = useLocation();
  const { setCurrentMenuActive } = useContext(SidebarNavItemCollapseContext);
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)');
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  useEffect(() => {
    if (isTablet) {
      setSidebarOpen(false);
      return;
    }
    if (isDesktop) {
      setSidebarOpen(true);
    }
  }, [isTablet, isDesktop, setSidebarOpen]);

  // Don't render Sidebar on mobile - Header will be used instead
  if (isMobile) {
    return null;
  }

  const openedTransition = {
    left: 244,
    transition: 'left 225ms cubic-bezier(0.4, 0, 0.6, 1)'
  };

  const closedTransition = {
    left: 65,
    transition: 'left 200ms cubic-bezier(0.4, 0, 0.6, 1)'
  };

  return (
    <SidebarContainer>
      <SidebarDoubleArrowToggleButton
        onClick={() => {
          setSidebarOpen(!sidebarOpen);
          setCurrentMenuActive(pathname.replace('/', ''));
        }}
        sx={sidebarOpen ? openedTransition : closedTransition}
        aria-label={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
        {...tid('common:layout:sidebar:toggle-button')}
      >
        <DoubleArrow style={{ color: 'white', transform: sidebarOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
      </SidebarDoubleArrowToggleButton>
      <Box>
        <StyledDrawer variant="permanent" open={sidebarOpen}>
          <SidebarLogo sx={{ padding: sidebarOpen ? '1.25rem 0 4rem 0' : '1.25rem 0 0 0' }}>
            <Logo expanded={sidebarOpen} />
          </SidebarLogo>
          <PerfectScrollbar className="disable_ps__rail-x">
            <SidebarList />
          </PerfectScrollbar>
          <SidebarNavUser name={userName} />
        </StyledDrawer>
      </Box>
    </SidebarContainer>
  );
};

export default Sidebar;
